export default {
  feedbackUrl: "https://back.net-ray.com",
  apiUrl: "https://backend.scra-ping.com",
  price: {
    minimal: {
      price: 9.95,
      discount: 0,
      newPrice: 0,
    },
    economy: {
      price: 10.95,
      discount: 0,
      newPrice: 0,
    },
    littleBit: {
      price: 12.95,
      discount: 0,
      newPrice: 0,
    },
    optimal: {
      price: 14.95,
      discount: 0,
      newPrice: 0,
    },
    littleBitMore: {
      price: 18.95,
      discount: 0,
      newPrice: 0,
    },
    largest: {
      price: 22.95,
      discount: 0,
      newPrice: 0,
    },
    ultimate: {
      price: 24.95,
      discount: 0,
      newPrice: 0,
    },
  },
};
